export const generateUniqueId = () => Math.floor(Math.random() * 1000000000);
